import { authenticatedFetch } from '../shared/authenticatedFetch';

export interface ProjectMetadataRecord {
  area_level_1: string;
  division: string | null;
  software_company: string | null;
  updated_at: string;
  updated_by: string;
}

export interface UpsertProjectMetadataRequest {
  division: string | null;
  software_company: string | null;
}

export interface AuditLogEntry {
  id: number;
  table_name: string;
  record_id: string;
  action: string;
  changed_by: string;
  changed_at: string;
  details: string | null;
}

export interface PagedAuditLogResponse {
  items: AuditLogEntry[];
  total_count: number;
  page: number;
  limit: number;
  total_pages: number;
}

export async function getProjectMetadata(apiUrl: string): Promise<ProjectMetadataRecord[]> {
  const response = await authenticatedFetch(`${apiUrl}/project-metadata`);
  return response.json();
}

export async function upsertProjectMetadata(
  apiUrl: string,
  areaLevel1: string,
  body: UpsertProjectMetadataRequest,
): Promise<ProjectMetadataRecord> {
  const response = await authenticatedFetch(
    `${apiUrl}/project-metadata?areaLevel1=${encodeURIComponent(areaLevel1)}`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
  return response.json();
}

export async function getAuditLogs(
  apiUrl: string,
  recordId: string,
): Promise<PagedAuditLogResponse> {
  const params = new URLSearchParams({
    tableName: 'ProjectMetadata',
    recordId,
    limit: '50',
  });
  const response = await authenticatedFetch(`${apiUrl}/audit-logs?${params.toString()}`);
  return response.json();
}
